import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Breadcrumbs, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../../../../Hooks/stateProvider";
import axios from "axios";
import Loader from "../../../../Loader/Loader";
import CommentDialogBox from "../../../CommonLayouts/CommentDialogBox";
import CommentComponent from "../../../CommonLayouts/CommentComponent";
import { ls } from "../../../../variables";
import Styles from "../styles/main.module.css";
import ViewCard from "../../../../components/ViewCard";
import { encrypt } from "../../../../utils/cipher";
import { errorHandler } from "../../../../utils/errorHandling";

function PMSTrackerView() {
  
  const userType = ls.get("userType");
  const pmsname = ls.get("pmsName");
  const navigate = useNavigate();
  const [{ PMSTrackerData, PMSTrackerPageData, moduleType }, dispatch] = useStateValue();
  const [selectedInstID, setSelectedInstID] = React.useState(
    PMSTrackerPageData?.instanceID?.split(",")
  );

  const [receivedData, setReceivedData] = useState({});
  const [open, setOpen] = React.useState(false);

  const fetchData = async () => {
    dispatch({ type: "SHOW_LOADER" });
    const payload = {
      fy_year: PMSTrackerData.fy_year,
      quarter: PMSTrackerData.quarter,
      pmsName: pmsname,
      ticketid: PMSTrackerPageData.ticketID,
      moduleType:moduleType,
      authToken: ls.get("authToken"),
      refreshToken: ls.get("refreshToken")
    };
    const encryptedPayload = await encrypt(payload)
    axios
      .post("/api/pms/viewPageFetchAPI", { payload: encryptedPayload }, {
        withCredentials: true
      })
      .then((receivedData) => {
        dispatch({ type: "HIDE_LOADER" });
        setReceivedData(receivedData);

        setOpen(false)


        if(moduleType=="ALERT" && PMSTrackerPageData.pmsTrackerViewStatus=="pending" && receivedData?.data?.data?.alert_remarks[0].s3Location){
          dispatch({ type: "fileName", fileName:receivedData?.data?.data?.alert_remarks[0].uploadedfileName })
          //dispatch({ type: "fileDetails", fileDetails:Details })
        }else{
          dispatch({ type: "fileName", fileName:""})
        }
      })
      .catch((err) => { 
        dispatch({ type: "HIDE_LOADER" });
        errorHandler(err, navigate);
      });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    
    fetchData();
  }, []);

 

  return (
    <>
      <Loader />
      <div className={Styles.FullBody}>
        <div className={Styles.navBody}>
          <Breadcrumbs className={Styles.historyNav} aria-label="breadcrumb">
            <Link
              underline="hover"
              color="inherit"
              onClick={() => navigate("/app/tracker")}
            >
              Tracker
            </Link>
            <Link
              underline="hover"
              color="inherit"
            >
              View
            </Link>
          </Breadcrumbs>
        </div>
        <div className={Styles.HeaderBody} style={{ marginTop: "1%" }}>
          <Grid container gap={"0.5rem"} display="flex" padding={"0.5rem"} height={"max-content"} >
            <Grid item xs={11.8} sm={11.8} md={3.1} className={Styles.gridBox} height={"auto"}>
              <ViewCard cardHeader={"Ticket ID"} cardContent={PMSTrackerPageData.ticketID} />
            </Grid>

            <Grid item xs={11.8} sm={11.8} md={3.1} className={Styles.gridBox} height={"auto"}>
              <ViewCard cardHeader={"Guidance Type"} cardContent={PMSTrackerPageData.guidanceType} />
            </Grid>
            <Grid item xs={11.8} sm={11.8} md={5.4} className={Styles.gridBox} height={"max-content"} >
              <ViewCard cardHeader={"Total Instance Count"} cardContent={PMSTrackerPageData.instanceCount} />
            </Grid>


          </Grid>
          <Box
            style={{
              overflowY: "auto",
              height: "43vh",
              width: "100%",


            }}
          >
            <Grid xs={11.8} padding={"0.5rem !important"}>
              {receivedData?.data?.data?.alert_remarks.map((rowData, index) => (

                <div key={index} style={{paddingBottom:"0.2rem"}} >
                  <CommentComponent
                    userType={userType}
                    pmsComment={rowData?.pmscomments}
                    ppaComment={rowData?.proposedplanofaction}
                    sebiComment={rowData?.sebicomments}
                    date={rowData?.date}
                    filePath={rowData?.uploadS3FilePath}
                    remarksArray={receivedData?.data.data.alert_remarks}
                    index={index}
                    status={PMSTrackerPageData.pmsTrackerViewStatus}
                    rowStatus={rowData?.status}
                    instanceCount={rowData?.instancecount}
                  />
                </div>
              ))}
            </Grid>
          </Box>
          <div style={{ justifyContent: "center", display: "flex" }}>
            <Grid
              item
              style={{
                marginTop: "2%",
                justifyContent: "center",
                height: "10%",
              }}


            >
         {PMSTrackerPageData.pmsTrackerViewStatus=="pending"?(    <button
                onClick={handleClickOpen}
                className={Styles.Preview}
                style={{ backgroundColor:  "#154063", }}
              >
                EDIT COMMENT
              </button>):(    
          <button
                onClick={handleClickOpen}
                className={Styles.Preview}
                style={{ backgroundColor: (receivedData?.data?.data?.alert_remarks[receivedData?.data?.data?.alert_remarks.length-1].rtacomments!=undefined) || (userType=="PMS" && receivedData?.data?.data?.alert_remarks[receivedData?.data?.data?.alert_remarks.length-1].pmscomments!=undefined) || receivedData?.data?.data?.alert_status=="closed"? "#808080" : "#154063", 
                  border: ( receivedData?.data?.data?.alert_remarks[receivedData?.data?.data?.alert_remarks.length-1].rtacomments!=undefined) || (userType=="PMS" && receivedData?.data?.data?.alert_remarks[receivedData?.data?.data?.alert_remarks.length-1].pmscomments!=undefined) || receivedData?.data?.data?.alert_status=="closed" ? "0.125rem solid #808080" : "0.125rem solid #154063",
                }}
                disabled={( receivedData?.data?.data?.alert_remarks[receivedData?.data?.data?.alert_remarks.length-1].rtacomments!=undefined) || (userType=="PMS" && receivedData?.data?.data?.alert_remarks[receivedData?.data?.data?.alert_remarks.length-1].pmscomments!=undefined) || receivedData?.data?.data?.alert_status=="closed"?true:false}
              >
                ADD COMMENT
              </button>)}     
     
              {open && (
                <CommentDialogBox
                  userType={userType}
                  open={open}
                  setOpen={setOpen}
                  fetchData={fetchData}
                  selectedInstID={selectedInstID}
                  statusPending={PMSTrackerPageData.pmsTrackerViewStatus}
                  remarks={receivedData?.data.data.alert_remarks}
                  caseIdCount={PMSTrackerPageData.caseIdCount}
                />
              )}
            </Grid>
          </div>
        </div>
      </div>
    </>
  );
}

export default PMSTrackerView;
